import { createListenerMiddleware } from '@reduxjs/toolkit';
import { constant, createListenerEffect } from '@socialive/common';
import { JoinBroadcastLinkType } from '~/helpers/enums';
import { setLinkType } from '~/store/joinBroadcast';

export const effect = createListenerEffect(
  'setGuestLinkType<Listener>',
  async (action, { dispatch, unsubscribe, trigger }) => {
    unsubscribe();

    const queryParams = new URLSearchParams(document.location.search);

    if (queryParams.has('claim')) {
      return dispatch(setLinkType({ type: JoinBroadcastLinkType.GUEST, trigger }));
    }

    if (queryParams.has('broadcast')) {
      return dispatch(setLinkType({ type: JoinBroadcastLinkType.BROADCAST, trigger }));
    }

    return undefined;
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  matcher: constant(true),
  effect,
});

export default middleware;
